/**
 * 桜の花びらクラス
 */

// 設定
import config from './config';


export default class {

    /**
     * コンストラクタ
     * PIXI.loader.add() で読み込ませた画像の name を指定する
     * @param {String} name
     */
    constructor(name) {
        // 現在のページの設定
        this.page_config = config.PAGE_SETTINGS[config.PAGE_ACTIVE];
        // 縮尺率
        this.scale = 0;
        // 落下速度
        this.speed_y = 0;
        // 風の強さ
        this.wind = 0;
        // ゆらぎ
        this.frequency = 0;
        // 角度
        this.rotate = Math.random() * this.page_config.SAKURA_ROTATE;
        // スクロール範囲
        this.area_width = 0;
        this.area_height = 0;
        // PIXI.jsのスプライト。基準座標を中心にする
        this.sprite = new PIXI.Sprite(PIXI.loader.resources[name].texture);
        this.sprite.anchor.x = 0.5;
        this.sprite.anchor.y = 0.5;

        // 1〜4秒の間にゆらぎ変更
        setInterval(() => {
            this.change_frequency();
        }, Math.floor((Math.random() * 3) * 1000) + 1000);
        this.change_frequency();
    }

    /**
    * 縮尺率を設定
    */
    set_scale(scale) {
        this.scale = scale;
        this.sprite.scale.x = scale;
        this.sprite.scale.y = scale;
        this.speed_y = this.page_config.SAKURA_SPEED_Y * scale;
    }

    /**
    * ウィンドウサイズ設定と、ランダム配置
    */
    attach_random(w, h) {
        this.area_width = w;
        this.area_height = h;
        this.sprite.x = (Math.random() * w) + config.SAKURA_MARGIN;
        this.sprite.y = (Math.random() * h) - config.SAKURA_MARGIN;
    }

    /**
    * 落下
    */
    fall() {
        const sprite = this.sprite;
        const margin = config.SAKURA_MARGIN;

        // 風の強さ
        this.wind += (this.frequency - this.wind) * 0.1;

        let x = sprite.x + ((this.page_config.WIND_WIND * this.scale)
            + this.wind);
        let y = sprite.y + this.speed_y;

        // 画面外に出た
        if (x < -margin || y > this.area_height + margin) {
            // 上に出すか、右に出すか
            if (Math.random() > 0.5) {
                // 上
                x = (Math.random() * this.area_width) + margin;
                y = -margin;
            } else {
                // 右
                x = this.area_width + margin;
                y = (Math.random() * this.area_height) - margin;
            }
        }

        sprite.x = x;
        sprite.y = y;
        sprite.rotation += this.rotate;
    }

    /**
    * 風のゆらぎを変更する（x座標のみ）
    */
    change_frequency() {
        this.frequency = (Math.random() * this.page_config.WIND_FREQUENCY)
            - (this.page_config.WIND_FREQUENCY / 2);
    }

}











// WEBPACK FOOTER //
// ./js/module/flower/SakuraClass.js